import { userSearchRestService } from '../../dataaccess/users/userSearchService'
import { UserResult } from './types/UserResult'

class UserSearchService {
    public searchForUsers = (q: string): Promise<UserResult[]> => userSearchRestService.search(q)
}

export const userSearchService = new UserSearchService()
